import { Component } from '@angular/core';
import {  NavController, NavParams, MenuController } from 'ionic-angular';
import { OfertaYNoticia } from '../../models/ofertaynoticia.model';
import { BuscadorPage } from '../buscador/buscador';
import { VariablesGlobales } from '../../providers/variables-globales';

/**
 * Generated class for the OfertaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-oferta',
  templateUrl: 'oferta.html',
})
export class OfertaPage {

  public oferta: OfertaYNoticia;

  constructor(public navCtrl: NavController, public navParams: NavParams,public menuCtrl:MenuController, public global: VariablesGlobales,) {
    this.oferta = this.navParams.get("oferta");
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  compartir(){
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad OfertaPage');
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }
}



// WEBPACK FOOTER //
// ./src/pages/oferta/oferta.ts